import { Component, OnInit, OnChanges } from '@angular/core';
import {
  Campus,
  Cluster,
  CLUSTERS,
  CAMPUSES,
  ApiService,
  LocalStorageService,
 } from '../../../shared';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-map-page',
  templateUrl: './map-page.component.html',
})
export class MapPageComponent implements OnInit {
  title: string = 'map';
  subtitle: string = 'lórien';

  clusters;
  campuses;
  campus: Campus;
  cluster: Cluster;

  constructor(
    private apiService: ApiService,
    private storageService: LocalStorageService
  ) {
      this.clusters = CLUSTERS;
      this.campuses = CAMPUSES;
    }

  ngOnInit() {
    this.getMyCampus(); 
    this.getCurrentCluster();
  }

  getMyCampus() {
    this.apiService.getMyCampus()
      .subscribe(campus => {
        this.campus = campus;
      });
  }

  getCurrentCluster() {
    this.storageService.getClusterName().pipe(
      switchMap(clusterName => this.apiService.getCluster(clusterName))
    ).subscribe(cluster => {
      this.cluster = cluster
      this.subtitle = cluster.name == CLUSTERS.IL ? '' : cluster.name;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/map/pages/map-page/map-page.component.ts